module.exports = __webpack_public_path__ + "img/Galactapedia_Gatac_Manufacture.78999976.png";